import { Component, Inject, Input, ViewChild } from '@angular/core';
import { OrderService } from '../../../models/orders/orderService';
import { Options } from '../../ui/filterable-table/options';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TableView } from '../../ui/filterable-table/tableView';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderDetailsTableViewComponent } from '../order-details-table-view/order-details-table-view.component';
import { TransactionService } from '../../../models/transactions/transactionService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { Router } from '@angular/router';
import { UIHelpers } from '../../../core/ui-helpers';
import { AccessManager } from '../../ui/access-manager/access-manager';

@Component({
  selector: 'app-orders-popup',
  standalone: false,
  templateUrl: './orders-popup.component.html',
})
export class OrdersPopupComponent {
  @ViewChild('ordersTransactionsTable') ordersTransactionsTableControl:
    | OrderDetailsTableViewComponent
    | undefined;

  allowEditTransactions: boolean = false;

  tableView: any;
  selectedTransaction: Partial<TransactionFacade> | undefined;
  selectedTransactions: TransactionFacade[] = [];
  transactionsTableOptions: Options = new Options({
    debug: 'transactions',
    selectAction: 'popup',
    filterable: false,
  });

  orderId: string = '';
  invoiceNumber: string = '';
  merchantId: string = '';

  customerName: string = '';
  merchantName: string = '';
  transactionsCount: number = 0;
  
  loading: boolean = true;
  sentReceipt: boolean = false;
  sendingSaleReturn: boolean = false;
  sendingReceiptErrors: string[] = [];

  hasBeenPartiallyRefunded: boolean = false;
  partiallyRefundedAmount: string = '';

  constructor(
    public dialogRef: MatDialogRef<OrdersPopupComponent>,
    private orderService: OrderService,
    private transactionService: TransactionService,
    private uiErrorHandler: UIErrorHandler,
    private router: Router,
    private uiHelpers: UIHelpers,
    private accessManager: AccessManager,
    @Inject(MAT_DIALOG_DATA)
    public data: { orderId: string; invoiceNumber: string; merchantId: string; customerName: string; merchantName: string; transactionsCount: number },
  ) {
    this.orderId = data.orderId;
    this.invoiceNumber = data.invoiceNumber;
    this.merchantId = data.merchantId;
    this.customerName = data.customerName;
    this.merchantName = data.merchantName;
    this.transactionsCount = data.transactionsCount;
    this.tableView = new TableView(OrderDetailsTableViewComponent);
  }

  async ngOnInit() {
    const access = await this.accessManager.getUserAccess(AccessManager.AUTH_INSERT_MERCHANT_TRANSACTIONS);
    this.allowEditTransactions = access[AccessManager.AUTH_INSERT_MERCHANT_TRANSACTIONS];
  }

  close_click() {
    this.loading = false;
    this.sentReceipt = false;
    this.sendingSaleReturn = false;
    this.sendingReceiptErrors = [];
    this.hasBeenPartiallyRefunded = false;
    this.partiallyRefundedAmount = '';
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    if (this.orderId) {
      this.transactionsTableOptions.orderId = this.orderId;
      this.transactionsTableOptions.invoiceNumber = this.invoiceNumber;
      this.transactionsTableOptions.merchantId = this.merchantId;
      this.ordersTransactionsTableControl?.setOptions(
        this.transactionsTableOptions,
      );
    }
  }

  returnToOrderDetails() {
    this.loading = false;
    this.sentReceipt = false;
    this.sendingSaleReturn = false;
    this.sendingReceiptErrors = [];
    this.hasBeenPartiallyRefunded = false;
    this.partiallyRefundedAmount = ''; 
  }

  onGenericOutputEvent(event: any) {
    switch (event.message) {
      case 'Table data loaded':
        this.loading = false;
        break;
      case 'Selected transactions changed':
        this.selectedTransactions = event.selectedTransactions;
        break;
    }
  }

  onSendReceiptClicked() {
    let receiptCount = 0;
    this.loading = true;
    for (const transaction of this.selectedTransactions) {
      this.orderService
        .getOrder(transaction.orderId!)
        .then((order) => {
          this.transactionService
            .sendTransactionToCustomer(
              order.recipientEmail!,
              order,
              transaction.type!,
            )
            .then(() => {
              receiptCount++;
              if (receiptCount === this.selectedTransactions.length) {
                this.loading = false;
                this.sentReceipt = true;
              }
            })
            .catch((error) => {
              this.sendingReceiptErrors.push(error.message);
              receiptCount++;
            });
        })
        .catch((error) => {
          this.sendingReceiptErrors.push(error.message);
          receiptCount++;
        });
    }
  }

  onBeginSaleReturn() {
    if (this.selectedTransactions[0]?.maxRefundAmount! != this.selectedTransactions[0]?.magnifiedAmount!) {
      this.hasBeenPartiallyRefunded = true;
      this.partiallyRefundedAmount = this.uiHelpers.formatCurrencyToString(
        this.uiHelpers.demagnifyAmount(
          this.selectedTransactions[0]?.magnifiedAmount! -
          this.selectedTransactions[0]?.maxRefundAmount!,
        this.selectedTransactions[0]?.magnifier!,
        ),
      );
    } else {
      this.hasBeenPartiallyRefunded = false;
      this.partiallyRefundedAmount = "";
    }
    this.sendingSaleReturn = true;
  }

  onSaleReturn() {
    this.dialogRef.close(true);
    if (this.selectedTransactions.length > 0) {
      this.router.navigate([
        'merchants/terminal',
        'tid',
        this.selectedTransactions[0].id,
        'v',
        '4',
      ]);
    }
  }
}
